import { DateRanges } from '../DateRanges';
import { PHODPageData } from '../general';
export var initPHRequestBuilder = function (_a) {
    var _b, _c;
    var customerType = _a.customerType, customerRole = _a.customerRole, searchParams = _a.searchParams, dateSelectorValue = _a.dateSelectorValue, svocID = _a.svocID, initResultsFilter = _a.initResultsFilter;
    var OPExpSessionData = PHODPageData();
    var createInitSearchBy = function () {
        var _a;
        if (searchParams.get('requestSearchSelectorValue') &&
            searchParams.get('requestSearchCriteria')) {
            var criteria = searchParams.get('requestSearchSelectorValue') || '';
            var value = searchParams.get('requestSearchCriteria') || '';
            var initSearchBy = (_a = {}, _a[criteria] = value, _a);
            return [initSearchBy];
        }
        return undefined;
    };
    if (customerType === 'b2b' || customerRole !== '') {
        return {
            pageSize: 20,
            pageNumber: (_b = OPExpSessionData === null || OPExpSessionData === void 0 ? void 0 : OPExpSessionData.lastPage) !== null && _b !== void 0 ? _b : 1,
            startDate: searchParams.get('startDate') ||
                DateRanges[dateSelectorValue].startDate,
            endDate: searchParams.get('endDate') || DateRanges[dateSelectorValue].endDate,
            customerAccountId: svocID || '',
            sortBy: 'salesDate',
            sortOrder: 'desc',
            searchType: 'ORDERS',
            resultsFilter: initResultsFilter,
            searchBy: createInitSearchBy(),
        };
    }
    return {
        pageSize: 20,
        pageNumber: (_c = OPExpSessionData === null || OPExpSessionData === void 0 ? void 0 : OPExpSessionData.lastPage) !== null && _c !== void 0 ? _c : 1,
        startDate: DateRanges[dateSelectorValue].startDate,
        endDate: DateRanges[dateSelectorValue].endDate,
    };
};
export var formatDate = function (dateStr) {
    if (!dateStr)
        return dateStr;
    var _a = dateStr.split('/'), part1 = _a[0], part2 = _a[1], part3 = _a[2];
    if (dateStr.includes('-'))
        return dateStr;
    if (part1 && part2 && part3) {
        return "".concat(part3, "-").concat(part1.padStart(2, '0'), "-").concat(part2.padStart(2, '0'));
    }
    return dateStr;
};
